<button mat-raised-button *appRole="['Movimientos.Crear']" color="primary" (click)="openDialogNuevoMovimientoCaja()">
  <mat-icon>add</mat-icon>
  Nuevo movimiento de caja
</button>
